import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // site: "xjjdcj-tw_data",
    site: 'xn_data'
  },
  mutations: {},
  actions: {},
  modules: {}
})
